import React, { createContext, useContext, useState } from 'react';

type CalcOpContextType = {
  calcOpInProgress: boolean;
  setCalcOpInProgress: (_value: boolean) => void;
};

const CalcOpContext = createContext<CalcOpContextType | undefined>(
  undefined,
);

export const CalcOpProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [calcOpInProgress, setCalcOpInProgress] =
    useState<boolean>(false);

  const update = (value: boolean) => {
    setCalcOpInProgress(value);
    localStorage.removeItem('calcOpInProgress');
  };

  return (
    <CalcOpContext.Provider
      value={{ calcOpInProgress, setCalcOpInProgress: update }}
    >
      {children}
    </CalcOpContext.Provider>
  );
};

export const useCalcOp = () => {
  const context = useContext(CalcOpContext);
  if (!context)
    throw new Error('useCalcOp must be used within a CalcOpProvider');
  return context;
};
